import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, border }) {
  return (
    <Wrapper
      className="animate pointer radius8"
      onClick={action ? () => action() : null}
      border={border}
    >
      {title}
    </Wrapper>
  );
}

const Wrapper = styled.button`
  border: 1px solid ${(props) => (props.border ? "#707070" : "#7C1877FF")};
  background-color: ${(props) => (props.border ? "transparent" : "#7C1877FF")};
  width: 100%;
  padding: 15px;
  outline: none;
  color: ${(props) => (props.border ? "#707070" : "#fff")};
  :hover {
    background-color: ${(props) => (props.border ? "transparent" : "#7C1877FF")};
    border: 1px solid #7C1877FF;
    color: ${(props) => (props.border ? "#7C1877FF" : "#fff")};
  }
`;

